import { SVGProps } from "react";

const UserAddIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 19.673C15 17.4638 12.3137 15.673 9 15.673C5.68629 15.673 3 17.4638 3 19.673M19 16.673V13.673M19 13.673V10.673M19 13.673H16M19 13.673H22M9 12.673C6.79086 12.673 5 10.8821 5 8.67297C5 6.46383 6.79086 4.67297 9 4.67297C11.2091 4.67297 13 6.46383 13 8.67297C13 10.8821 11.2091 12.673 9 12.673Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UserAddIcon;
